/*
 *
 * TimeSpanPlannerPage reducer
 *
 */

import {fromJS} from "immutable";
import {
  GET_AVAILABILITY_SCANNERS,
  GET_AVAILABILITY_SCANNERS_FAILED,
  GET_AVAILABILITY_SCANNERS_SUCCESS,
  GET_RESULT,
  GET_RESULT_FAILED,
  GET_RESULT_SUCCESS,
  GET_TIMESLOT_DRIVERS,
  GET_TIMESLOT_DRIVERS_FAILED,
  GET_TIMESLOT_DRIVERS_SUCCESS,
  GET_TIMESLOTS,
  GET_TIMESLOTS_FAILED,
  GET_TIMESLOTS_SUCCESS,
  REMOVE_ACTIVITY,
  RESET,
  SAVE_ACTIVITY,
} from "./constants";

export const initialState = fromJS({
  timeWindows: [],
  loading: false,
  activity: null,
  // Result
  result: null,
  resultLoading: true,
  resultFailed: null,
  // drivers
  drivers: [],
  drivesLoading: false,
  scannersLoading: false,
  scanners: null
});

function timeSpanPlannerPageReducer(state = initialState, action) {
  switch (action.type) {
    // Get time slots
    case GET_TIMESLOTS:
      return state.set("loading", true);
    case GET_TIMESLOTS_SUCCESS:
      return state
        .set(
          "timeWindows",
          fromJS(action.result.additional_data.available_timewindows),
        )
        .set("loading", false);
    case GET_TIMESLOTS_FAILED:
      return state.set("loading", false).set("timeWindows", fromJS([]));
    /**
     * Activity
     */
    case SAVE_ACTIVITY:
      return state.set("activity", action.activity);
    case REMOVE_ACTIVITY:
      return state.set("activity", null);
    /**
     * Result
     */
    case GET_RESULT:
      return state.set("resultLoading", true);
    case GET_RESULT_FAILED:
      return state
        .set("resultFailed", action.reason)
        .set("resultLoading", false);
    case GET_RESULT_SUCCESS:
      return state
        .set("resultFailed", null)
        .set("result", action.result)
        .set("resultLoading", false);
    case GET_TIMESLOT_DRIVERS:
      return state.set("drivers", []).set("driversLoading", true);
    case GET_TIMESLOT_DRIVERS_FAILED:
      return state.set("driversLoading", false);
    case GET_TIMESLOT_DRIVERS_SUCCESS:
      return state.set("drivers", action.drivers).set("driversLoading", false);
    case GET_AVAILABILITY_SCANNERS:
      return state.set("scanners", null).set("scannersLoading", true);
    case GET_AVAILABILITY_SCANNERS_FAILED:
      return state.set("scannersLoading", false);
    case GET_AVAILABILITY_SCANNERS_SUCCESS:
      return state.set("scanners", action.scanners).set("scannersLoading", false);
    /**
     * Reset
     */
    case RESET:
      return initialState;
    default:
      return state;
  }
}

export default timeSpanPlannerPageReducer;
